<header class="top">
  <mat-icon (click)="closeModal()" >close</mat-icon>
  </header>
  <app-generic-graph-handler 
    [graphData]="data"
    [colors]="graphColors"
    [enableDataLabels]="false"
    [showDataLabels]="false"
    [showTools]="false">
  </app-generic-graph-handler>
  <br>
  <div>
    <h3>Filter criteria:</h3>
    <p><b>Group: {{ data.GraphDashboard?.groupName }}</b></p>
    <p><b>Displaying transactions:</b>&nbsp;every {{ data.Interval }} grouped by {{ data.TimeFrame?.name }} for {{ data.Timeperiod?.name }}</p>
</div>